var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirefoxIconicLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58447 7.9098C2.33857 12.1925 3.90637 17.4848 8.12259 19.8532C12.3388 22.2215 17.6741 20.8069 20.163 16.6607C22.6519 12.5144 21.3915 7.14065 17.3188 4.53332C15.3687 3.3175 12.4238 2.92392 10.8657 3.52037",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46436 9.56334C3.72051 8.00519 4.66493 4.22055 5.57261 3.43602C5.65801 4.32582 6.15356 4.63566 6.67592 5.10936C7.54983 4.83626 7.97984 4.82931 8.53001 5.10936C9.34433 4.20566 10.2123 2.77164 11.1398 3.03084C10.0653 4.7598 11.0703 6.73802 12.5013 7.17497C12.3325 8.14323 11.0276 9.07474 9.76044 9.84239C8.4734 10.7739 9.04343 11.6796 9.76044 12.0609C10.7029 12.5634 13.6287 10.9161 14.5562 12.2557C12.87 12.357 12.84 13.972 10.3185 15.1206C12.8241 16.071 14.6335 15.5794 15.7388 14.783C17.6902 13.2735 18.5979 11.2655 18.5979 9.26442C18.584 7.87609 18.7905 6.58806 17.3466 4.54728",
    stroke: "#841474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxIconicLogo);
export default __webpack_public_path__ + "static/media/firefox-iconic-logo.27eabe20.svg";
export { ForwardRef as ReactComponent };